<template>
  <head>
    <meta charset="utf-8" />
    <title>HOSPITAL MANAGEMENT INFORMATION SYSTEM</title>
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <meta content="HMIS By Craft Silicon Payments" name="description" />
    <meta content="Kelvin Njuguna" name="author" />
    <!-- App favicon -->
    <link rel="shortcut icon" href="assets/images/favicon.svg">
    <!-- droping file -->
    <link href="assets/libs/dropzone/min/dropzone.min.css" rel="stylesheet" type="text/css" />

    <!-- DataTables -->
    <link href="assets/libs/datatables.net-bs4/css/dataTables.bootstrap4.min.css" rel="stylesheet" type="text/css" />
    <link href="assets/libs/datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css" rel="stylesheet" type="text/css" />

    <!-- Bootstrap Css -->
    <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
    <!-- Bootstrap select styling -->
    <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css">
    <!-- Icons Css -->
    <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css" />

    <!-- owl.carousel css -->
    <link rel="stylesheet" href="assets/libs/owl.carousel/assets/owl.carousel.min.css">

    <link rel="stylesheet" href="assets/libs/owl.carousel/assets/owl.theme.default.min.css">
    <!-- App Css-->
    <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
    <!-- custom Css-->
    <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css" />
  </head>

  <body data-sidebar="dark">
  <div id="layout-wrapper">
    <!-- ========== Left Sidebar Start ========== -->
    <NavigationBar/>
    <!-- Left Sidebar End -->

    <!-- ============================================================== -->
    <!-- Start right Content here -->
    <!-- ============================================================== -->
    <div class="main-content">
      <div class="page-content">
        <div class="container-fluid">
          <!-- start page title -->
          <div class="row">
            <div class="col-12">
              <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4 class="mb-sm-0 font-size-18">Affiliated Institutions</h4>

                <div class="page-title-right">
                  <ol class="breadcrumb m-0">
                    <li class="breadcrumb-item"><a href="index.html">Dashboards</a></li>
                    <li class="breadcrumb-item"><a href="#">Organization Structure</a></li>
                    <li class="breadcrumb-item"><a href="#">Affiliated Institutions</a></li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
          <!-- end page title -->

          <div class="row">
            <div class="col-12">
              <div class="card">
                <div class="card-header bg-white pt-0 pr-0 p-0 d-flex justify-content-between align-items-center w-100 border-bottom">
                  <div class="btn-toolbar p-3 d-flex justify-content-between align-items-center w-100" role="toolbar">
                    <h4 class="card-title text-uppercase mb-0">
                      All Available Affiliated Institutions
                    </h4>

                    <div class="d-flex">
                      <button @click="showCreateModal" type="button" class="btn btn-primary waves-effect btn-label waves-light text-uppercase">
                        <i class="bx bx-plus label-icon"></i> New Affiliated Institution
                      </button>
                    </div>
                  </div>
                </div>

                <div class="card-header bg-white border-bottom py-3">
                  <div class="btn-toolbar d-flex justify-content-between align-items-center w-100" role="toolbar">
                    <div class="flex-grow-1">
                      <div class="search-box mb-0 me-3">
                        <div class="position-relative">
                          <input v-model="filters.searchTerm" @input="searchInstitutions" type="text" class="form-control bg-light border-light rounded" placeholder="Search..." spellcheck="false">
                          <i class="bx bx-search-alt search-icon"></i>
                        </div>
                      </div>
                    </div>

                    <div class="d-flex">
                      <div class="d-flex align-items-center">
                        <div class="d-flex justify-content-between">
                          <div class="float-end d-flex">
                            <div class="input-group fw-semibold text-uppercase me-3">
                              <label class="input-group-text text-uppercase">Status</label>
                              <select v-model="filters.status" @change="searchInstitutions" class="form-select">
                                <option value="">All Statuses</option>
                                <option value="active">Active</option>
                                <option value="inactive">Inactive</option>
                                <option value="suspended">Suspended</option>
                              </select>
                            </div>

                            <div class="input-group fw-semibold text-uppercase" title="Select the starting date to filter records based on the last edit date.">
                              <label class="input-group-text text-uppercase">From:</label>
                              <input v-model="filters.startDate" @change="searchInstitutions" class="form-control form-control-sm" type="date">
                            </div>

                            <div class="input-group fw-semibold text-uppercase" title="Select the ending date to filter records based on the last edit date.">
                              <label class="input-group-text text-uppercase">To:</label>
                              <input v-model="filters.endDate" @change="searchInstitutions" class="form-control form-control-sm" type="date">
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card-body">
                  <!-- Loading state -->
                  <div v-if="loading" class="text-center py-4">
                    <div class="spinner-border text-primary" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                    <p class="mt-2">Loading institutions...</p>
                  </div>

                  <!-- Table -->
                  <div v-else class="table-responsive">
                    <table class="table align-middle table-hover contacts-table text-uppercase border">
                      <thead class="table-light">
                      <tr>
                        <th scope="col">SN</th>
                        <th scope="col">Affiliated Institution</th>
                        <th scope="col">Employees Count</th>
                        <th scope="col">Status</th>
                        <th scope="col">Country</th>
                        <th>Last Updated</th>
                        <th class="text-right">Actions</th>
                      </tr>
                      </thead>
                      <tbody class="border">
                      <tr v-for="(institution, index) in institutions" :key="institution.institution_id">
                        <td>{{ (currentPage - 1) * pageSize + index + 1 }}.</td>
                        <td>{{ institution.institution_name }} <span v-if="institution.institution_code" class="text-grey fw-bold opacity-50">({{ institution.institution_code }})</span></td>
                        <td>{{ institution.employee_count || 0 }}</td>
                        <td class="fw-bold text-black">
                          <p class="mb-2 text-truncate">
                            <i :class="getStatusIcon(institution.status)"></i> {{ formatStatus(institution.status) }}
                          </p>
                        </td>
                        <td>{{ institution.country_name }}</td>
                        <td>{{ formatDate(institution.updated_at) }}</td>
                        <td class="text-uppercase text-right">
                          <div class="d-flex justify-content-end">
                            <button @click="editInstitution(institution)" class="btn btn-sm btn-success text-uppercase" title="Edit Affiliated Institution">Edit</button>
                            <button @click="showInstitutionDetails(institution)" class="btn btn-sm btn-info text-uppercase mx-2" title="View Affiliated Institution Details">Details</button>
                            <button v-if="institution.status === 'active'" @click="showDeactivateModal(institution)" class="btn btn-sm btn-danger text-uppercase d-flex align-items-center" title="Deactivate Affiliated Institution">
                              <div>Deactivate</div>
                            </button>
                            <button v-else @click="activateInstitution(institution)" class="btn btn-sm btn-primary text-uppercase d-flex align-items-center" title="Activate Affiliated Institution">
                              <div>Activate</div>
                            </button>
                          </div>
                        </td>
                      </tr>
                      </tbody>
                    </table>

                    <!-- Empty state -->
                    <div v-if="institutions.length === 0" class="text-center py-4">
                      <p class="text-muted">No institutions found</p>
                    </div>

                    <!-- Pagination -->
                    <div v-if="totalCount > pageSize" class="row mt-3">
                      <div class="col-sm-12 col-md-5">
                        <div class="dataTables_info">
                          Showing {{ (currentPage - 1) * pageSize + 1 }} to {{ Math.min(currentPage * pageSize, totalCount) }} of {{ totalCount }} entries
                        </div>
                      </div>
                      <div class="col-sm-12 col-md-7">
                        <div class="dataTables_paginate paging_simple_numbers float-end">
                          <ul class="pagination">
                            <li class="paginate_button page-item previous" :class="{ disabled: currentPage === 1 }">
                              <a @click="changePage(currentPage - 1)" class="page-link">Previous</a>
                            </li>
                            <li v-for="page in totalPages" :key="page" class="paginate_button page-item" :class="{ active: currentPage === page }">
                              <a @click="changePage(page)" class="page-link">{{ page }}</a>
                            </li>
                            <li class="paginate_button page-item next" :class="{ disabled: currentPage === totalPages }">
                              <a @click="changePage(currentPage + 1)" class="page-link">Next</a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Creating New Affiliated Institution Modal -->
      <div v-if="showCreate" class="modal fade show d-block" tabindex="-1" style="background-color: rgba(0,0,0,0.5)">
        <div class="modal-dialog modal-dialog-centered modal-lg">
          <div class="modal-content modal-md">
            <div class="modal-header border-bottom-0">
              <h4 class="modal-title text-uppercase">Create New Affiliated Institution</h4>
              <button type="button" class="btn-close" @click="closeCreateModal"></button>
            </div>
            <div class="modal-body">
              <div v-if="alert.show" :class="`alert alert-${alert.type}`" role="alert">
                {{ alert.message }}
              </div>

              <div class="row">
                <div class="col-4 mb-3">
                  <div class="mb-3">
                    <label for="institution-name" class="form-label">Institution Name<strong class="text-danger fw-bold">*</strong></label>
                    <input v-model="form.institutionName" type="text" class="form-control" id="institution-name" placeholder="Enter Institution Name" required>
                  </div>
                </div>

                <div class="col-4 mb-3">
                  <div class="mb-3">
                    <label for="institution-status" class="form-label">Status<strong class="text-danger fw-bold">*</strong></label>
                    <select v-model="form.status" id="institution-status" class="form-select" required>
                      <option value="" disabled>Select Status</option>
                      <option value="active">Active</option>
                      <option value="inactive">Inactive</option>
                    </select>
                  </div>
                </div>

                <div class="col-4 mb-3">
                  <div class="mb-3">
                    <label for="institution-country" class="form-label">Country<strong class="text-danger fw-bold">*</strong></label>
                    <select v-model="form.countryCode" id="institution-country" class="form-select" required>
                      <option value="ET">Ethiopia</option>
                      <option value="KE">Kenya</option>
                      <option value="UG">Uganda</option>
                      <option value="TZ">Tanzania</option>
                      <option value="RW">Rwanda</option>
                    </select>
                  </div>
                </div>

                <div class="col-12 mb-3">
                  <div class="mb-3">
                    <label for="institution-description" class="form-label">Description</label>
                    <textarea v-model="form.description" id="institution-description" placeholder="Enter Description" class="form-control" rows="3"></textarea>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <div class="d-flex flex-wrap gap-2 text-uppercase">
                <button @click="createInstitution" :disabled="createLoading" type="submit" class="btn btn-primary waves-effect waves-light">
                  <span v-if="createLoading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  {{ createLoading ? 'Saving...' : 'Save' }}
                </button>
                <button @click="closeCreateModal" type="button" class="btn btn-secondary waves-effect">
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Edit Affiliated Institution Modal -->
      <div v-if="showEdit" class="modal fade show d-block" tabindex="-1" style="background-color: rgba(0,0,0,0.5)">
        <div class="modal-dialog modal-dialog-centered modal-lg">
          <div class="modal-content modal-md">
            <div class="modal-header border-bottom-0">
              <h4 class="modal-title text-uppercase">Edit Affiliated Institution</h4>
              <button type="button" class="btn-close" @click="closeEditModal"></button>
            </div>
            <div class="modal-body">
              <div v-if="alert.show" :class="`alert alert-${alert.type}`" role="alert">
                {{ alert.message }}
              </div>

              <div class="row">
                <div class="col-4 mb-3">
                  <div class="mb-3">
                    <label for="edit-institution-name" class="form-label">Institution Name<strong class="text-danger fw-bold">*</strong></label>
                    <input v-model="editForm.institutionName" type="text" class="form-control" id="edit-institution-name" placeholder="Enter Institution Name" required>
                  </div>
                </div>

                <div class="col-4 mb-3">
                  <div class="mb-3">
                    <label for="edit-institution-status" class="form-label">Status<strong class="text-danger fw-bold">*</strong></label>
                    <select v-model="editForm.status" id="edit-institution-status" class="form-select" required>
                      <option value="" disabled>Select Status</option>
                      <option value="active">Active</option>
                      <option value="inactive">Inactive</option>
                      <option value="suspended">Suspended</option>
                    </select>
                  </div>
                </div>

                <div class="col-4 mb-3">
                  <div class="mb-3">
                    <label for="edit-institution-country" class="form-label">Country<strong class="text-danger fw-bold">*</strong></label>
                    <select v-model="editForm.countryCode" id="edit-institution-country" class="form-select" required>
                      <option value="ET">Ethiopia</option>
                      <option value="KE">Kenya</option>
                      <option value="UG">Uganda</option>
                      <option value="TZ">Tanzania</option>
                      <option value="RW">Rwanda</option>
                    </select>
                  </div>
                </div>

                <div class="col-12 mb-3">
                  <div class="mb-3">
                    <label for="edit-institution-description" class="form-label">Description</label>
                    <textarea v-model="editForm.description" id="edit-institution-description" placeholder="Enter Description" class="form-control" rows="3"></textarea>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <div class="d-flex flex-wrap gap-2 text-uppercase">
                <button @click="updateInstitution" :disabled="editLoading" type="submit" class="btn btn-primary waves-effect waves-light">
                  <span v-if="editLoading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  {{ editLoading ? 'Saving...' : 'Save Changes' }}
                </button>
                <button @click="closeEditModal" type="button" class="btn btn-secondary waves-effect">
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Deactivate Modal -->
      <div v-if="showDeactivate" class="modal fade show d-block" tabindex="-1" style="background-color: rgba(0,0,0,0.5)">
        <div class="modal-dialog modal-dialog-centered modal-lg">
          <div class="modal-content modal-md">
            <div class="modal-header border-bottom-0">
              <h4 class="modal-title text-uppercase">Deactivate Affiliated Institution</h4>
              <button type="button" class="btn-close" @click="closeDeactivateModal"></button>
            </div>
            <div class="modal-body">
              <div v-if="alert.show" :class="`alert alert-${alert.type}`" role="alert">
                {{ alert.message }}
              </div>

              <p>Are you sure you want to deactivate the affiliated institution <strong class="text-primary">{{ selectedInstitution?.institution_name }}</strong>?</p>
              <div class="row">
                <div class="col-12 mb-3">
                  <label for="deactivation-reason" class="form-label">Reason for Deactivation (Optional)</label>
                  <textarea v-model="deactivateReason" id="deactivation-reason" placeholder="Provide reason for deactivation" class="form-control" rows="3"></textarea>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <div class="d-flex flex-wrap gap-2 text-uppercase">
                <button @click="deactivateInstitution" :disabled="deactivateLoading" type="submit" class="btn btn-danger waves-effect waves-light">
                  <span v-if="deactivateLoading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  {{ deactivateLoading ? 'Processing...' : 'Confirm Deactivation' }}
                </button>
                <button @click="closeDeactivateModal" type="button" class="btn btn-secondary waves-effect">
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Institution Details Modal -->
      <div v-if="showDetails" class="modal fade show d-block" tabindex="-1" style="background-color: rgba(0,0,0,0.5)">
        <div class="modal-dialog modal-dialog-centered modal-xl">
          <div class="modal-content">
            <div class="modal-header border-bottom-0">
              <h4 class="modal-title text-uppercase">Institution Details</h4>
              <button type="button" class="btn-close" @click="closeDetailsModal"></button>
            </div>
            <div class="modal-body">
              <div v-if="detailsInstitution" class="row">
                <div class="col-12">
                  <h5 class="text-primary mb-3">{{ detailsInstitution.institution_name }}</h5>
                </div>

                <div class="col-md-4 mb-3">
                  <div class="p-3 border rounded bg-light">
                    <label class="text-muted text-uppercase small mb-1">Institution Code</label>
                    <p class="mb-0 fw-semibold">{{ detailsInstitution.institution_code || 'N/A' }}</p>
                  </div>
                </div>

                <div class="col-md-4 mb-3">
                  <div class="p-3 border rounded bg-light">
                    <label class="text-muted text-uppercase small mb-1">Status</label>
                    <p class="mb-0 fw-semibold">
                      <i :class="getStatusIcon(detailsInstitution.status)"></i>
                      {{ formatStatus(detailsInstitution.status) }}
                    </p>
                  </div>
                </div>

                <div class="col-md-4 mb-3">
                  <div class="p-3 border rounded bg-light">
                    <label class="text-muted text-uppercase small mb-1">Employee Count</label>
                    <p class="mb-0 fw-semibold">{{ detailsInstitution.employee_count || 0 }}</p>
                  </div>
                </div>

                <div class="col-md-4 mb-3">
                  <div class="p-3 border rounded bg-light">
                    <label class="text-muted text-uppercase small mb-1">Country</label>
                    <p class="mb-0 fw-semibold">{{ detailsInstitution.country_name }} ({{ detailsInstitution.country_code }})</p>
                  </div>
                </div>

                <div class="col-md-4 mb-3">
                  <div class="p-3 border rounded bg-light">
                    <label class="text-muted text-uppercase small mb-1">Institution ID</label>
                    <p class="mb-0 fw-semibold">#{{ detailsInstitution.institution_id }}</p>
                  </div>
                </div>

                <div class="col-md-4 mb-3">
                  <div class="p-3 border rounded bg-light">
                    <label class="text-muted text-uppercase small mb-1">Created By</label>
                    <p class="mb-0">{{ detailsInstitution.created_by_name }} {{ detailsInstitution.created_by_lastname }}</p>
                  </div>
                </div>

                <div class="col-12 mb-3">
                  <div class="p-3 border rounded bg-light">
                    <label class="text-muted text-uppercase small mb-1">Description</label>
                    <p class="mb-0">{{ detailsInstitution.description || 'No description available' }}</p>
                  </div>
                </div>

                <div class="col-md-6 mb-3">
                  <div class="p-3 border rounded bg-light">
                    <label class="text-muted text-uppercase small mb-1">Created Date</label>
                    <p class="mb-0">{{ formatDate(detailsInstitution.created_at) }}</p>
                  </div>
                </div>

                <div class="col-md-6 mb-3">
                  <div class="p-3 border rounded bg-light">
                    <label class="text-muted text-uppercase small mb-1">Last Updated</label>
                    <p class="mb-0">{{ formatDate(detailsInstitution.updated_at) }}</p>
                  </div>
                </div>
              </div>

              <!-- Loading State -->
              <div v-else class="text-center py-5">
                <div class="spinner-border text-primary" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
                <p class="mt-2">Loading details...</p>
              </div>
            </div>
            <div class="modal-footer">
              <div class="d-flex flex-wrap gap-2 text-uppercase">
                <button
                    type="button"
                    @click="closeDetailsModal"
                    class="btn btn-secondary waves-effect"
                >
                  Close
                </button>
                <button
                    type="button"
                    @click="editFromDetails"
                    class="btn btn-primary waves-effect"
                >
                  <i class="mdi mdi-pencil me-1"></i> Edit
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <footer class="footer">
        <div class="container-fluid">
          <div class="row">
            <div class="col-sm-6">
              © Hospital Management Information System
            </div>
            <div class="col-sm-6">
              <div class="text-sm-end d-sm-block">
                2024
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  </div>

  <!-- Right bar overlay-->
  <div class="rightbar-overlay"></div>
  </body>
</template>

<script>
/* eslint-disable */
import NavigationBar from "@/components/Navigation.vue";
import { authUrl, executeJson } from "@/api";

export default {
  name: "AffiliatedInstitution",
  components: { NavigationBar },
  data() {
    return {
      // Loading states
      loading: false,
      createLoading: false,
      editLoading: false,
      deactivateLoading: false,

      // Modal states
      showCreate: false,
      showEdit: false,
      showDeactivate: false,
      showDetails: false,

      // Data
      institutions: [],
      selectedInstitution: null,
      detailsInstitution: null,
      deactivateReason: '',

      // Pagination
      currentPage: 1,
      pageSize: 50,
      totalCount: 0,

      // Filters
      filters: {
        searchTerm: '',
        status: '',
        startDate: '',
        endDate: ''
      },

      // Forms
      form: {
        institutionName: '',
        status: 'active',
        countryCode: 'ET',
        description: ''
      },

      editForm: {
        institutionId: '',
        institutionName: '',
        status: '',
        countryCode: '',
        description: ''
      },

      // Alert
      alert: {
        show: false,
        type: 'success',
        message: ''
      }
    };
  },

  computed: {
    totalPages() {
      return Math.ceil(this.totalCount / this.pageSize);
    }
  },

  mounted() {
    this.fetchInstitutions();
  },

  methods: {
    // Fetch institutions
    async fetchInstitutions() {
      this.loading = true;
      this.clearAlert();

      const data = {
        function: "getAffiliatedInstitutions",
        status: this.filters.status,
        searchTerm: this.filters.searchTerm,
        startDate: this.filters.startDate,
        endDate: this.filters.endDate,
        limit: this.pageSize,
        offset: (this.currentPage - 1) * this.pageSize
      };

      try {
        const response = await executeJson(data, authUrl);

        if (response.data.success) {
          this.institutions = response.data.data.institutions || [];
          this.totalCount = response.data.data.total || 0;
        } else {
          this.showAlert('danger', response.data.message || 'Failed to fetch institutions');
        }
      } catch (error) {
        this.showAlert('danger', error.message || 'An error occurred while fetching institutions');
      } finally {
        this.loading = false;
      }
    },

    // Search institutions
    searchInstitutions() {
      this.currentPage = 1;
      this.fetchInstitutions();
    },

    // Change page
    changePage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
        this.fetchInstitutions();
      }
    },

    // Show institution details
    showInstitutionDetails(institution) {
      this.detailsInstitution = institution;
      this.showDetails = true;
    },

    // Edit from details modal
    editFromDetails() {
      if (this.detailsInstitution) {
        this.closeDetailsModal();
        this.editInstitution(this.detailsInstitution);
      }
    },

    // Close details modal
    closeDetailsModal() {
      this.showDetails = false;
      this.detailsInstitution = null;
    },

    // Show create modal
    showCreateModal() {
      this.showCreate = true;
      this.clearAlert();
      this.resetForm();
    },

    // Close create modal
    closeCreateModal() {
      this.showCreate = false;
      this.clearAlert();
      this.resetForm();
    },

    // Reset form
    resetForm() {
      this.form = {
        institutionName: '',
        status: 'active',
        countryCode: 'ET',
        description: ''
      };
    },

    // Create institution
    async createInstitution() {
      if (!this.form.institutionName) {
        this.showAlert('danger', 'Institution name is required');
        return;
      }

      this.createLoading = true;
      this.clearAlert();

      const data = {
        function: "createAffiliatedInstitution",
        institutionName: this.form.institutionName,
        status: this.form.status,
        countryCode: this.form.countryCode,
        description: this.form.description
      };

      try {
        const response = await executeJson(data, authUrl);

        if (response.data.success) {
          this.showAlert('success', response.data.message || 'Institution created successfully');
          setTimeout(() => {
            this.closeCreateModal();
            this.fetchInstitutions();
          }, 2000);
        } else {
          this.showAlert('danger', response.data.message || 'Failed to create institution');
        }
      } catch (error) {
        this.showAlert('danger', error.message || 'An error occurred while creating institution');
      } finally {
        this.createLoading = false;
      }
    },

    // Edit institution
    editInstitution(institution) {
      this.selectedInstitution = institution;
      this.editForm = {
        institutionId: institution.institution_id,
        institutionName: institution.institution_name,
        status: institution.status,
        countryCode: institution.country_code,
        description: institution.description || ''
      };
      this.showEdit = true;
      this.clearAlert();
    },

    // Close edit modal
    closeEditModal() {
      this.showEdit = false;
      this.clearAlert();
      this.selectedInstitution = null;
    },

    // Update institution
    async updateInstitution() {
      if (!this.editForm.institutionName) {
        this.showAlert('danger', 'Institution name is required');
        return;
      }

      this.editLoading = true;
      this.clearAlert();

      const data = {
        function: "updateAffiliatedInstitution",
        institutionId: this.editForm.institutionId,
        institutionName: this.editForm.institutionName,
        status: this.editForm.status,
        countryCode: this.editForm.countryCode,
        description: this.editForm.description
      };

      try {
        const response = await executeJson(data, authUrl);

        if (response.data.success) {
          this.showAlert('success', response.data.message || 'Institution updated successfully');
          setTimeout(() => {
            this.closeEditModal();
            this.fetchInstitutions();
          }, 2000);
        } else {
          this.showAlert('danger', response.data.message || 'Failed to update institution');
        }
      } catch (error) {
        this.showAlert('danger', error.message || 'An error occurred while updating institution');
      } finally {
        this.editLoading = false;
      }
    },

    // Show deactivate modal
    showDeactivateModal(institution) {
      this.selectedInstitution = institution;
      this.showDeactivate = true;
      this.clearAlert();
      this.deactivateReason = '';
    },

    // Close deactivate modal
    closeDeactivateModal() {
      this.showDeactivate = false;
      this.clearAlert();
      this.selectedInstitution = null;
      this.deactivateReason = '';
    },

    // Deactivate institution
    async deactivateInstitution() {
      this.deactivateLoading = true;
      this.clearAlert();

      const data = {
        function: "deactivateAffiliatedInstitution",
        institutionId: this.selectedInstitution.institution_id,
        reason: this.deactivateReason
      };

      try {
        const response = await executeJson(data, authUrl);

        if (response.data.success) {
          this.showAlert('success', response.data.message || 'Institution deactivated successfully');
          setTimeout(() => {
            this.closeDeactivateModal();
            this.fetchInstitutions();
          }, 2000);
        } else {
          this.showAlert('danger', response.data.message || 'Failed to deactivate institution');
        }
      } catch (error) {
        this.showAlert('danger', error.message || 'An error occurred while deactivating institution');
      } finally {
        this.deactivateLoading = false;
      }
    },

    // Activate institution
    async activateInstitution(institution) {
      if (confirm(`Are you sure you want to activate ${institution.institution_name}?`)) {
        const data = {
          function: "updateAffiliatedInstitution",
          institutionId: institution.institution_id,
          status: 'active'
        };

        try {
          const response = await executeJson(data, authUrl);

          if (response.data.success) {
            this.showAlert('success', 'Institution activated successfully');
            this.fetchInstitutions();
          } else {
            this.showAlert('danger', response.data.message || 'Failed to activate institution');
          }
        } catch (error) {
          this.showAlert('danger', error.message || 'An error occurred while activating institution');
        }
      }
    },

    // Utility methods
    formatDate(dateString) {
      if (!dateString) return 'N/A';
      const date = new Date(dateString);
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    },

    formatStatus(status) {
      return status.charAt(0).toUpperCase() + status.slice(1);
    },

    getStatusIcon(status) {
      const icons = {
        'active': 'mdi mdi-circle text-success me-1',
        'inactive': 'mdi mdi-circle text-danger me-1',
        'suspended': 'mdi mdi-circle text-warning me-1'
      };
      return icons[status] || 'mdi mdi-circle text-secondary me-1';
    },

    showAlert(type, message) {
      this.alert = {
        show: true,
        type: type,
        message: message
      };

      // Auto-hide success alerts after 5 seconds
      if (type === 'success') {
        setTimeout(() => {
          this.clearAlert();
        }, 5000);
      }
    },

    clearAlert() {
      this.alert = {
        show: false,
        type: 'success',
        message: ''
      };
    }
  }
};
</script>

<style scoped>
.spinner-border-sm {
  width: 1rem;
  height: 1rem;
}

.modal.show {
  display: block !important;
}

.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.search-icon {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  color: #74788d;
}

.pagination {
  margin-bottom: 0;
}

.page-link {
  cursor: pointer;
}

.page-item.disabled .page-link {
  cursor: not-allowed;
}

.page-item.active .page-link {
  background-color: #5664d2;
  border-color: #5664d2;
}

.bg-light {
  background-color: #f8f9fa !important;
}

.text-muted {
  color: #6c757d !important;
}

.small {
  font-size: .875em;
}

.modal-xl {
  max-width: 1140px;
}

.text-right {
  text-align: right !important;
}
</style>